import { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        axios.get(`${API}/testimonials`).then((r) => setItems(r.data.testimonials || [])).catch(() => {});
    }, []);

    if (items.length === 0) return null;

    return (
        <section id="avis" data-testid="testimonials-section" className="py-32 bg-[#1C1E1D] text-[#FAF9F6]">
            <div className="max-w-[1500px] mx-auto px-6 md:px-12">
                <div className="mb-16">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="h-px w-10 bg-[#B89C6A]" />
                        <span className="tracking-luxe text-[#B89C6A]">Ils nous font confiance</span>
                    </div>
                    <h2 className="font-serif-lux text-4xl md:text-5xl lg:text-6xl leading-[1.02] max-w-3xl">
                        La parole à <em className="italic text-[#B89C6A]">nos clients</em>.
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {items.slice(0, 6).map((t) => (
                        <figure
                            key={t.id}
                            data-testid={`testimonial-${t.id}`}
                            className="border border-[#FAF9F6]/10 p-8 flex flex-col justify-between hover:border-[#B89C6A]/50 transition-colors"
                        >
                            <div>
                                <div className="flex gap-1 mb-5">
                                    {Array.from({ length: t.rating || 5 }).map((_, i) => (
                                        <Star key={i} size={14} className="fill-[#B89C6A] text-[#B89C6A]" />
                                    ))}
                                </div>
                                <blockquote className="font-serif-lux text-lg leading-relaxed text-[#FAF9F6]/90">
                                    « {t.text} »
                                </blockquote>
                            </div>
                            <figcaption className="mt-8 pt-5 border-t border-[#FAF9F6]/10">
                                <div className="tracking-luxe text-[#B89C6A]">{t.author}</div>
                                <div className="text-[12px] text-[#FAF9F6]/50 mt-1">
                                    {[t.project, t.location].filter(Boolean).join(" · ")}
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
